import { useMemo } from 'react'
import { useSearchParams } from 'react-router'

import { SORT_PRODUCTS } from '@entities/Product/sort'

import type { SortDirection } from '@shared/types'



export type ProductSortKey = Extract<keyof typeof SORT_PRODUCTS, string>;

export interface ProductSortConfig {
  fieldName: string;
  value: string;
  direction: SortDirection;
}

export default function useProductSort () {
  const [ searchParams, setSearchParams ] = useSearchParams()

  const sortKey = (searchParams.get('sort') as ProductSortKey) ?? 'default'

  const sortConfig: ProductSortConfig = useMemo(
    () => SORT_PRODUCTS[sortKey],
    [ sortKey ],
  )

  const setSortKey = (newKey: ProductSortKey) => {
    setSearchParams(
      (params) => {
        const next = new URLSearchParams(params)
        next.set('sort', newKey)
        return next
      },
      { replace: true },
    )
  }

  return {
    sortKey,
    sortConfig,
    setSortKey,
  }
}
